const socialMediaMapping = (data) => {
  const mappedData = {};

  mappedData.title = data.field_title[0]?.value;
  mappedData.video_social = data.field_video_social[0]?.value;
  mappedData.video_type = {
    video_embed: data.field_video_embed[0]?.value,
    image: data.field_video_image[0]?.url
  };
  mappedData.text_social = data.field_text_social[0]?.value;
  mappedData.text_type = {
    social_detail_title: data.field_text_title[0]?.value,
    social_detail_content: data.field_text_body[0]?.value,
    social_detail_image: data.field_text_image[0]?.url,
    cta: {
      title: data.field_text_cta[0]?.title || '',
      alt: data.field_text_cta[0]?.options.attributes['aria-label'] || '',
      href: data.field_text_cta[0]?.url || '/',
      ariaLabel: data.field_text_cta[0]?.options.attributes['aria-label'] || ''
    }
  }

  return mappedData;
};


export default socialMediaMapping;
